import { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogHeader } from '../../Components/ui/dialog'
import { Sheet, SheetContent, SheetHeader } from '../../Components/ui/sheet'
import { Button } from '../../Components/ui/button'
import { useErrorPopupStore } from '../../store/useErrorPopupStore'
import env from '../../env/env'

export function ErrorPopup() {
  const { isOpen, title, description, onClose, hideErrorPopup } = useErrorPopupStore()

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIfMobile = () => setIsMobile(window.innerWidth < 768)
    checkIfMobile()
    window.addEventListener('resize', checkIfMobile)
    return () => window.removeEventListener('resize', checkIfMobile)
  }, [])

  const handleClose = () => {
    hideErrorPopup()
    if (onClose) onClose()
  }

  const ErrorContent = () => (
    <>
      <div className='flex flex-col justify-center items-center text-center space-y-10'>
        <img className='h-16 w-16' src={`${env.SVGS}/error.svg`} alt='Error' />
        <div className='space-y-2'>
          <h2 className='text-lg font-semibold'>{title}</h2>
          <p className='text-black-400 text-sm text-center'>{description}</p>
        </div>

        <Button
          className='bg-primary-500 hover:bg-primary-600 text-white px-10 w-full'
          size='sm'
          onClick={handleClose}
        >
          Close
        </Button>
      </div>
    </>
  )

  if (isMobile) {
    return (
      <Sheet open={isOpen} onOpenChange={handleClose}>
        <SheetContent side='bottom' className='rounded-t-3xl font-DMSans'>
          <SheetHeader>
            <ErrorContent />
          </SheetHeader>
        </SheetContent>
      </Sheet>
    )
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className='sm:max-w-[360px] font-DMSans rounded-none'>
        <DialogHeader>
          <ErrorContent />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
